var _style, _circle, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage03Layer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 400",
    style: {
      enableBackground: "new 0 0 500 400"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#ffcd00}.st1{clip-path:url(#SVGID_2_)}.st2{fill:#fff}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 241.42,
    cy: 198.82,
    r: 182.5
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 241.42,
    cy: 198.82,
    r: 182.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M310.39 71.2l-55.37 216.3h-62.54l-27.93-115.57L135.12 287.5H72.58L17.21 71.2h60.07l30.16 122.98L139.32 71.2h53.64l30.16 124.53L255.01 71.2H310.39z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage03Layer1);
export default __webpack_public_path__ + "static/media/image-03-layer-1.44c7c923aece92be439a05cb9ba89c20.svg";
export { ForwardRef as ReactComponent };